import classNames from "classnames";
import { Error } from "components/InputsMex/containers/components";
import React from "react";
import Select from "react-select";
import COLORS from "utils/constants/COLORS";

/**
 * @type {import("react-select").StylesConfig}
 */
const colorStyles = {
  valueContainer: (provided, state) => ({
    ...provided,
    fontSize: "19px",
    fontWeigth: "bold",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: "19px",
    fontWeigth: "bold",
    color: "#6c757d",
  }),
  menu: (styles) => ({ ...styles, borderRadius: "0" }),
  input: (styles) => ({
    ...styles,
    verticalAlign: "center",
    fontSize: "19px",
    fontWeight: "bold",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    border: "none",
    boxShadow: "none",
    verticalAlign: "center",
    borderRadius: "none",
  }),
  menuPortal: (styles) => ({ ...styles, zIndex: "300000000" }),
  option: (styles) => ({
    ...styles,
    backgroundColor: "white",
    textAlign: "left",
    fontSize: "19px",
    color: COLORS.dark,
    ":hover": {
      backgroundColor: COLORS.primary,
      color: COLORS.white,
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    fontSize: "19px",
    fontWeigth: "bold",    
  }),
};

/**
 *
 * @param {{
 *  errorMessage:string,
 *  disabled:boolean,
 *  hasError:boolean,
 *  value:any,
 *  onChange:(value:any)=>void,
 *  options:any[]
 * }} props
 *
 * @returns {React.FC}
 *
 */
const DropDownColumn = (props) => {
  const { onChange, value, options, hasError, disabled, errorMessage, placeholder } = props;

  return (
    <td
      className={classNames("border p-0 m-0 v-center text-left", {
        "border-danger bg-white": hasError,
      })}>
      <Select
        className='px-0'
        styles={colorStyles}
        value={value}
        onChange={onChange}
        options={options}
        isDisabled={disabled}
        placeholder={placeholder}
        menuPortalTarget={document.body}
      />
      {errorMessage && <Error className='px-2'>{errorMessage}</Error>}
    </td>
  );
};

export default DropDownColumn;
